"use client";
import { useCallback, useEffect, useState } from "react";
import { Button, Container, Typography } from "components/ct-design";
import {
  useModalDispatch,
  useGlobalState,
} from "src/context/globalStateContext/provider";
import HomeWallet from "icons/homeWallet.svg";
import { formatCurrency } from "src/utils/generalUtils";
import { isEmpty } from "src/utils/browserHelpers";
import AccountLogo from "src/icons/accountLogo.svg";
import useFetch from "src/network/useFetch";
import Clevertap from "src/analytics/index";
import { HOME_API_ENDPOINTS } from "constants/network";
import { Stencil } from "components/Stencil";
import { IWalletResponse } from "./type";
// import { getApiDomain } from "src/utils/apiHelpers";
import LoggedInDropdown from "components/LoggedInMenu";
import { handleUTMParams } from "src/utils/uiHelpers";
import { usePathname, useSearchParams } from "next/navigation";

// const accountInfoURL = HOME_API_ENDPOINTS.ACCOUNT_DETAILS;

const SignedInInfo = () => {
  const { abData, userDetails } = useGlobalState() || {};
  const { response: walletData, isLoading: walletLoading } =
    useFetch<IWalletResponse>(HOME_API_ENDPOINTS.HOME_WALLET_INFO);
  // const { response: accountDetailsResponse } =
  //   useFetch<IAccountDetailsResponse>(accountInfoURL, {
  //     headers: {
  //       caller: getApiDomain(),
  //     },
  //   });
  const { wallet } = walletData || {};
  const walletBalance = !isEmpty(wallet) && wallet?.[0]?.balance;
  const [showDropdown, setShowDropdown] = useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleOverlay = (apply: boolean) => {
    const rootLayout = document.querySelector(".root-layout");
    const overlayDiv = document.querySelector(".overlay");

    if (apply && !overlayDiv) {
      const overlayDiv = document.createElement("div");

      overlayDiv.className = "overlay";
      overlayDiv.style.zIndex = "70";
      rootLayout?.appendChild(overlayDiv);
    } else if (!apply) {
      overlayDiv && rootLayout?.removeChild(overlayDiv);
    }
  };

  const openDropdown = () => {
    setTimeout(() => {
      handleOverlay(true);

      setShowDropdown(true);
    }, 10);
  };

  const handleWalletClick = () => {
    Clevertap.event("BUS_UI_Action", {
      action_type: "BUTTON",
      action_name: "hp_wallet_click",
      walletBalance: walletBalance,
      wallet_icon_displayed:
        abData && abData?.wallet_display && abData?.wallet_display === "b"
          ? "yes"
          : "no",
    });
    window.location.href = "/accounts/wallet";
  };

  const handleDropdownClose = useCallback(() => {
    setShowDropdown(false);
    handleOverlay(false);
  }, []);

  useEffect(() => {
    if (showDropdown) setShowDropdown(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, searchParams]);

  return (
    <>
      {walletLoading ? (
        <Stencil width={75} height={15} shimmer />
      ) : (
        <Container className="flex mr-4 c-pointer">
          <Container onClick={handleWalletClick} className="flex">
            <Container className="flex flex-middle">
              <HomeWallet />
            </Container>
            <Container className="pl-2">
              <Typography variant="P3">
                {walletBalance ? formatCurrency(walletBalance) : "0"}
              </Typography>
            </Container>
          </Container>
        </Container>
      )}
      <Container
        onClick={openDropdown}
        className="p-2 flex flex-middle flex-between br-2 hoverGrey c-pointer"
      >
        <AccountLogo />
        <Container className="ml-2">
          <Typography variant="B2">My account</Typography>
        </Container>
      </Container>
      {showDropdown && (
        <LoggedInDropdown
          onClose={handleDropdownClose}
          accountInfo={userDetails}
        />
      )}
    </>
  );
};

const HomeUserProfile: React.FC = () => {
  const dispatch = useModalDispatch();
  const { isSignedIn } = useGlobalState() || {};
  useEffect(() => {
    handleUTMParams();
  }, []);

  const handleLogin = () => {
    //Dispatch ation to open login modal
    dispatch({ type: "OPEN_LOGIN_MODAL" });
  };

  const renderHeaderRight = () => {
    if (isSignedIn) {
      return <SignedInInfo />;
    } else {
      return (
        <Button
          size={"medium"}
          onClick={handleLogin}
          color="tertiary"
          style={{ padding: "6px 4px 8px 4px" }}
          minWidth={"128px"}
        >
          Log in / Sign up
        </Button>
      );
    }
  };

  return (
    <Container className="flex flex-middle">{renderHeaderRight()}</Container>
  );
};

export default HomeUserProfile;
